type NotificationType = 'DEFAULT' | 'WARNING';

export const PROJECT_NOTIFICATION_CONFIRM_ACTIONS = {
  CONFIRM_STAKEHOLDER_LIST: 'CONFIRM_STAKEHOLDER_LIST',
} as const;

export type ProjectNotificationType = {
  id: string;
  recipientAlias: String;
  type: NotificationType;
  message: String;
  metadata: {
    entityType: string;
    projectId?: string;
    entityId: string;
    scenario?: string;
    sinceDate?: string;
    confirmAction?: string;
  } | null;
};

export type CommercialStateNotificationData = {
  items: ProjectNotificationType[];
  total: number;
};
